import { useLayoutEffect } from 'react';
import { MessageBroker } from '~/Features/Messaging/MessageBroker';
import type { Message, MessageHandler } from '~/Features/Messaging/types';
import { useVariableWithStableRef } from '~/Utils/Hooks/useVariableWithStableRef';

export const useMessageHandler = (messageId: string, onMessage: MessageHandler['handle']) => {
    const onMessageRef = useVariableWithStableRef(onMessage);

    // We use LayoutEffect here because it is important that the handler is subscribed before the first message is published.
    // It could happen if the children of the component that uses this hook publish a message in their useEffect.
    useLayoutEffect(() => {
        const handler = {
            handle: (event: Message) => onMessageRef.current(event),
        };

        MessageBroker.subscribe(handler, messageId);

        return () => MessageBroker.unsubscribe(handler, messageId);
    }, [onMessageRef, messageId]);
};
